function AttackmentService() {
    this.constructor.apply(this, arguments);
}
AttackmentService.$inject = ['$mdToast', '$message', '$translationService','$Config', 'UtilityService', 'AuthService'];
AttackmentService.prototype = {
    /**
     *
     * @param $mdToast {$mdToast}
     * @param $message {$message}
     * @param $translationService {$translationService}
     * @param $Config {$Config}
     * @param UtilityService {UtilityService}
     * @param AuthService {AuthService}
     */
    constructor($mdToast, $message, $translationService, $Config, UtilityService, AuthService){
        this.$mdToast = $mdToast;
        this.$message = $message;
        this.$translationService = $translationService;
        this.$Config = $Config;
        this.utilityService = UtilityService;
        this.authService = AuthService;
    },
    isFileType(fileName, exts) {
        return _.find(exts, function (ext) {
            return fileName.toLocaleLowerCase().indexOf("." + ext) !== -1;
        });
    },
    /**
     * Get class icon to display icon of file
     * @param name
     * @returns {*}
     */
    getIcon(name) {
        if (!name)
            return 'fa-file-o';
        //Pdf
        if (this.isFileType(name, ['pdf']))
            return 'fa-file-pdf-o';
        //isPhoto
        if (this.isFileType(name, ['jpg', 'jpeg', 'psd', 'png', 'tiff', 'bmp', 'gif', 'ico']))
            return 'fa-file-image-o';
        //isExcel
        if (this.isFileType(name, ['xls', 'xlsx']))
            return 'fa-file-excel-o';
        //isWord
        if (this.isFileType(name, ['doc', 'docx']))
            return 'fa-file-word-o';
        //isPresentation
        if (this.isFileType(name, ['pps', 'ppt', 'pptx']))
            return 'fa-file-powerpoint-o';
        //isText
        if (this.isFileType(name, ['txt', 'text']))
            return 'fa-file-text-o';
        //isArchive
        if (this.isFileType(name, ['zip', 'zar', 'tar', '7z', 'gz']))
            return 'fa-file-archive-o';
        return 'fa-file-o';
    },
    /**
     * Determine fileName is photo
     * @param {string} name
     * @returns {boolean}
     */
    isPhoto(name) {
        if(!name){
            return false
        }
        if(name.indexOf('blob:')===0){
            return true;
        }
        return this.getIcon(name) === 'fa-file-image-o';
    },

    /**
     *
     * @param $files {File[]}
     * @returns {File[]}
     */
    getFiles($files) {
        if ($files.length === 0)
            return [];
        // Map $files
        $files.forEach(($file) => {
            $file.iconClass = this.getIcon($file.name);
            $file.isPhoto = this.isPhoto($file.name);
            $file.Id = _.uniqueId('file-');
            $file.Name = this.getAttachmentName($file);
            $file.uploadStatus = UploadStatus.Pending;
            $file.progress = 0;
            $file.isNew = true;
            //turn fail when filesize is 0
            if ($file.size === 0) {
                $file.uploadStatus = UploadStatus.Fail;
                $file.isPhoto = false;
            }
        })
        return $files;
    },

    /**
     * Get attackment name
     * @param {IFile} $file
     * @returns {string}
     */
    getAttachmentName($file) {
        var fileName = $file.name;
        // if ($file.isPhoto) {
        //     var ext = fileName.substr(fileName.lastIndexOf('.') + 1);
        //     fileName = _.uniqueId('photo-') + "." + ext;
        // }
        return this.removeSpecialCharacter(fileName);
    },
    removeSpecialCharacter(fileName) {
        return this.replaceAll(fileName, "+", "-");
    },
    replaceAll(target, search, replacement) {
        return target.split(search).join(replacement);
    },

    isExistFileUploadFail($files) {
        var failed = false;
        $files.forEach(($file) => {
            if ($file.uploadStatus === UploadStatus.Fail) {
                failed = true;
            }
        })
        return failed;
    },
    isUploading($files) {
        var isUploading = false;
        $files.forEach(($file) => {
            if ($file.uploadStatus === UploadStatus.Pending) {
                isUploading = true;
            }
        });
        return isUploading;
    },

    /**
     * Check files before save
     * @param $files {IAttachment[]}
     * @return {boolean}
     */
    checkFiles($files){
        //Show error if files upload fail
        if (this.isExistFileUploadFail($files)) {
            this.$mdToast.show(this.$mdToast
                .simple()
                .position("right top")
                .textContent(this.$message.get('FileUploadFail'))
                .action(this.$translationService.getTranslation('OK'))
                .hideDelay(6000));
            return false;
        }
        // Show error if files is uploading
        if (this.isUploading($files)) {
            this.$mdToast.show(this.$mdToast
                .simple()
                .position("right top")
                .textContent(this.$message.get('FileUploadPending'))
                .action(this.$translationService.getTranslation('OK'))
                .hideDelay(6000));
            return false;
        }
        return true;
    },

    /**
     * Get document url from documentId
     * @param documentId {string}
     * @returns {string}
     */
    buildDocumentUrl(documentId) {
        return this.utilityService.addSlashIfNotExists(this.$Config.apiUrl) + "mobile/document/download/" + this.authService.getSessionId() + "/" + documentId;
    },

    /**
     * Get thumb url from documentId
     * @param documentId {string}
     * @returns {string}
     */
    buildThumbUrl(documentId) {
        return this.buildDocumentUrl(documentId) + '/thumb.jpg';
    },

    /**
     * Build the url to view in full size
     * @param documentId {string}
     * @param name {string}
     */
    buildFullImageUrl(documentId, name) {
        return this.buildDocumentUrl(documentId) + '/'+(name||'full.jpeg');
    },

    buildImageUrl(item){
        if(!item){
            return;
        }
        let items = [];
        if(Array.isArray(item)){
            items = item;
        } else{
            items = [item];
        }
        items.forEach(($item) => {
            if($item.DocumentId){
                $item.ThumbnailUrl = this.buildThumbUrl($item.DocumentId);
                $item.DownloadUrl = this.buildFullImageUrl($item.DocumentId, $item.Name);
            }
        })
    },

    /**
     *
     * @param attachments {VehicleBookingAttachment[]}
     * @return {VehicleBookingAttachment[]}
     */
    getAttachmentFiles(attachments) {
        if (!attachments) {
            return [];
        }
        attachments.forEach((attachment) => {
            attachment.iconClass = this.getIcon(attachment.Name);
            attachment.isPhoto = this.isPhoto(attachment.Name);
        });
        return attachments;
    }
}

angular.module('shared').service('AttackmentService', AttackmentService);
